import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { FunctionComponent } from 'react';
import styles from './LeadActivityRowSkeleton.module.scss';

const LeadActivityRowSkeleton: FunctionComponent = () => {
    return (
        <TableRow>
            <TableCell>
                <span className={styles.stack}>
                    <span className={styles.line} />
                    <span className={`${styles.line} ${styles.short}`} />
                </span>
            </TableCell>
            <TableCell>
                <span className={styles.line} />
            </TableCell>
            <TableCell>
                <span className={styles.stack}>
                    <span className={`${styles.line} ${styles.wide}`} />
                    <span className={`${styles.line} ${styles.short}`} />
                </span>
            </TableCell>
            <TableCell>
                <span className={styles.line} />
            </TableCell>
        </TableRow>
    );
};

export default LeadActivityRowSkeleton;
